<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="sendEmail" @vm-close="close" vm-size="medium" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalSendEmail" :vm-is-valid="!$v.form.$invalid" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-tabs
        vm-tab(vm-label="Generales")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            b-form-group
              vm-tabs
                vm-tab(vm-label='Español' @click="changeLangEs")
                vm-tab(vm-label='Ingles' @click="changeLangEn")
              label.vm-input--label Correos electronicos (Max 10)
                .chips
                  .chip(:key="index" v-for="(email, index) in form.emails")
                    span {{ email }}
                    span.chip__close(@click="remove(index)") X
                vm-input(type="text" v-model="newEmail" @keyup.enter="addEmail" placeholder="Ingresa el correo y enter para ingresar más" :danger="emailError" :danger-text="emailError")
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group.separator
              vm-input(v-model="form.attention" :danger="!$v.form.attention.required" danger-text="Attention is required" label='Atención a' placeholder="Ingresa a quien va dirigido")
          vm-col(vm-justify="center", vm-align="center", vm-w=6)
            b-form-group.separator
              vm-input(v-model="form.subject" :danger="!$v.form.subject.required" danger-text="Subject is required" :label="$t('email.subject')" :placeholder="$t('email.subject_placeholder')")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            b-form-group
              vm-text-editor(v-model="form.body" :danger="!$v.form.body.required" danger-text="Content is required" :label="$t('email.body_placeholder')" :placeholder="$t('email.body_placeholder')")
        vm-tab(vm-label="Adjuntos")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
              .ddrop(v-cloak='' @drop.prevent='addFile' @dragover.prevent='')
                h2(v-if='files.length < 3' @click="$refs.file.click()") Archivos adjuntos (Arrastra o click aqui)
                ul
                  li(v-for='file in files') {{ file.name }} ({{ file.size | kb }} kb)
                    vm-button(@click='removeFile(file)' title='Remove') x
                input.hide(type="file" ref="file" multiple accept="application/msword, image/jpeg, image/x-png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document" @change="handleFileUpload")
            vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-if="model == 'quotations'")
              vm-table(max-height="350px" :data="quotationProducts")
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('products.' + column) }}
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                      slot(v-if="column != 'attachment' && column != 'supplier_id' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
                      vm-checkbox(v-if="column == 'tech_sheet' && hasTech(data[indextr])" v-model="data[indextr].include_tech" @input='includeTech(data[indextr])')
                      vm-checkbox(v-if="column == 'security_sheet' && hasSecurity(data[indextr])" v-model="data[indextr].include_security" @input='includeSecurity(data[indextr])')
</template>

<script>
import { required, email, maxLength } from 'vuelidate/lib/validators' // Ver documentacion
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalSendEmail',
  props: {
    title: {
      type: String,
      default: 'Enviar por correo'
    },
    model: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    emails: {
      type: Array,
      default: () => {}
    },
    quotationProducts: {
      type: Array,
      default: () => {}
    }
  },
  data: () => ({
    form: {
      emails: [],
      attachmentsIds: []
    },
    props: {},
    files: [],
    columns: [
      'name',
      'tech_sheet',
      'security_sheet'
    ],
    checkbox: [],
    newEmail: '',
    emailError: null
  }),
  validations: {
    form: {
      attention: {
        required
      },
      emails: {
        required,
        maxLength: maxLength(10),
        $each: {
          email
        }
      },
      subject: {
        required
      },
      body: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalSendEmail'
    ])
  },
  watch: {
    isModalSendEmail (flag) {
      if (flag) {
        this.form.emails = this.emails
      }
    }
  },
  methods: {
    ...mapActions([
      'sendEmailRecord',
      'setModalSendEmail'
    ]),
    remove (index) {
      this.form.emails.splice(index, 1)
    },
    sendEmail () {
      this.form.files = this.files
      this.sendEmailRecord({ model: this.model, id: this.id, form: this.form })
    },
    close () {
      this.form.emails = []
      this.setModalSendEmail(false)
    },
    changeLangEs () {
      this.form.lang = 'es'
    },
    changeLangEn () {
      this.form.lang = 'en'
    },
    addFile (e) {
      let droppedFiles = e.dataTransfer.files
      if (!droppedFiles) {
        return
      }
      ([...droppedFiles]).forEach(f => {
        this.files.push(f)
      })
      this.form.files = this.files
    },
    removeFile (file) {
      this.files = this.files.filter(f => {
        return f !== file
      })
      this.form.files = this.files
    },
    async handleFileUpload ({ target }) {
      ([...target.files]).forEach(f => {
        this.files.push(f)
      })
      this.form.files = this.files
    },
    hasTech (product, index) {
      var id = product.attachments.find(a => a.pivot.file_type === 'tech_sheet')
      return id ? id.id : ''
    },
    hasSecurity (product, index) {
      var id = product.attachments.find(a => a.pivot.file_type === 'security_sheet')
      return id ? id.id : ''
    },
    includeTech (product) {
      product.include_tech && this.form.attachmentsIds.push(this.hasTech(product))
      !product.include_tech && this.form.attachmentsIds.pop(this.hasTech(product))
    },
    includeSecurity (product) {
      product.include_security && this.form.attachmentsIds.push(this.hasSecurity(product))
      !product.include_security && this.form.attachmentsIds.pop(this.hasSecurity(product))
    },
    addEmail () {
      if (this.newEmailIsValid()) {
        this.form.emails.push(this.newEmail)
        this.newEmail = ''
      }
    },
    newEmailIsValid () {
      const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
      if (this.newEmail.length > 100) {
        this.emailError = 'El correo no puede tener más de 100 caracteres'
        return false
      } else if (!regex.test(this.newEmail)) {
        this.emailError = 'El correo no tiene un formato válido'
        return false
      } else {
        this.emailError = null
        return true
      }
    }
  }
}
</script>

<style lang="scss">
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
.ddrop {
  height: 15vh;
  width: 100%;
  border: dashed 1px;
  border-radius: 10px;
  padding: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  ul {
    list-style-type: none;
  }
}
.hide {
  display: none;
}

.chip {
  width: 100%;
  background-color: #f1f1f1;
  border-radius: 20px;
  text-align: center;
  margin: 10px 0;
  padding: 5px 0;
  &__close {
    border-radius: 50%;
    width: 20px;
    display: inline-block;
  }
  &__close:hover {
    background-color: red;
  }
}
</style>
